import { ACCESS } from "@dictybase/auth-mui5"
import { Front } from "../features/Frontpage/Front"

// eslint-disable-next-line unicorn/prefer-export-from, import/no-default-export
export default Front
export const access = ACCESS.public
